var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrapper-page',{ref:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.isLoadingVesselBuilders)?_c('vessel-builders-table',{attrs:{"showSearchBar":false,"vesselBuilders":_vm.vesselBuilders}}):_vm._e()],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }